package io.horion.cv.api.datasource.payement

enum class ServiceType {
    CV
}